export default __webpack_public_path__ + "static/media/os-block-diagram.67e144b7.jpg";